var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91061 20.5886C5.91061 19.7486 6.59061 19.0686 7.43061 19.0686C8.26061 19.0686 8.94061 19.7486 8.94061 20.5886C8.94061 21.4186 8.26061 22.0986 7.43061 22.0986C6.59061 22.0986 5.91061 21.4186 5.91061 20.5886ZM17.1606 20.5886C17.1606 19.7486 17.8406 19.0686 18.6806 19.0686C19.5106 19.0686 20.1906 19.7486 20.1906 20.5886C20.1906 21.4186 19.5106 22.0986 18.6806 22.0986C17.8406 22.0986 17.1606 21.4186 17.1606 20.5886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1908 6.34909C20.8008 6.34909 21.2008 6.55909 21.6008 7.01909C22.0008 7.47909 22.0708 8.13909 21.9808 8.73809L21.0308 15.2981C20.8508 16.5591 19.7708 17.4881 18.5008 17.4881H7.5908C6.2608 17.4881 5.1608 16.4681 5.0508 15.1491L4.1308 4.24809L2.6208 3.98809C2.2208 3.91809 1.9408 3.52809 2.0108 3.12809C2.0808 2.71809 2.4708 2.44809 2.8808 2.50809L5.2658 2.86809C5.6058 2.92909 5.8558 3.20809 5.8858 3.54809L6.0758 5.78809C6.1058 6.10909 6.3658 6.34909 6.6858 6.34909H20.1908ZM14.1308 11.5481H16.9008C17.3208 11.5481 17.6508 11.2081 17.6508 10.7981C17.6508 10.3781 17.3208 10.0481 16.9008 10.0481H14.1308C13.7108 10.0481 13.3808 10.3781 13.3808 10.7981C13.3808 11.2081 13.7108 11.5481 14.1308 11.5481Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersFilled);
export default __webpack_public_path__ + "static/media/orders_filled.95bbdd9c424cbda11b4b1ddbac927fd4.svg";
export { ForwardRef as ReactComponent };